import { AlertProps, SvgIcon } from '@mui/material';
import { ReactComponent as SuccessIcon } from 'assets/icons/success.svg';
import React, { memo } from 'react';
import { themes } from 'themes';

import { StyledSuccessAlert } from '../Alert.styled';

const SuccessAlert: React.FC<Omit<AlertProps, 'severity' | 'square'>> = memo(props => {
  const icon = (
    <SvgIcon component={SuccessIcon} inheritViewBox data-testid="success-icon" htmlColor={themes.colors.success[40]} />
  );

  return (
    <StyledSuccessAlert {...props} severity="success" icon={icon}>
      {props.children}
    </StyledSuccessAlert>
  );
});

export default SuccessAlert;
